import { defineMessages } from "react-intl";

export const messages = defineMessages({
  account: {
    defaultMessage: "Configuration account",
    id: "new-managed-tenant-wizard.general.account",
  },

  legacyAccount: {
    defaultMessage: "Connection account",
    id: "new-managed-tenant-wizard.general.legacyAccount",
  },

  accountPlaceholder: {
    defaultMessage: "Enter account name like username@domain.com",
    id: "new-managed-tenant-wizard.general.account-placeholder",
  },

  accountRecommendation: {
    defaultMessage: "Account requirement:",
    id: "new-managed-tenant-wizard.general.account-recommentations",
  },

  accountRequirementsLabel: {
    defaultMessage: "Account requirements:",
    id: "new-managed-tenant-wizard.general.account-accountRequirementsLabel",
  },

  accountRecommendation1: {
    defaultMessage: "Create a separate account for Cayosoft Guardian",
    id: "new-managed-tenant-wizard.general.account-recommentation1",
  },
  accountRecommendation2: {
    defaultMessage: "Account must not be synced from on-premise Active Directory",
    id: "new-managed-tenant-wizard.general.account-recommentation2",
  },
  accountRecommendation3: {
    defaultMessage: "Account must be a member of Global Admins role",
    id: "new-managed-tenant-wizard.general.account-recommentation3",
  },

  accountRecommendation4: {
    defaultMessage: "Account must be a member of the Global Administrator role",
    id: "new-managed-tenant-wizard.general.account-recommentation4",
  },

  accountRequirements: {
    defaultMessage:
      "This account is used by Cayosoft Guardian to connect to your Microsoft 365 tenant, retrieve configuration data, and perform operations required for monitoring and alerting.",
    id: "new-managed-tenant-wizard.general.account-requirement",
  },

  accountRequirementsPrincipal: {
    defaultMessage:
      "This application account is used by Cayosoft Guardian to connect to your Microsoft 365 tenant, retrieve configuration data, and perform operations required for monitoring and alerting.",
    id: "new-managed-tenant-wizard.general.accountRequirementsPrincipal",
  },

  recommendedAccountStep: {
    defaultMessage: "Specify configuration account",
    id: "new-managed-tenant-wizard.general.stepname",
  },

  accountStep: {
    defaultMessage: "Specify connection account",
    id: "new-managed-tenant-wizard.general.accountStep",
  },

  recommendedSubTitle: {
    defaultMessage:
      "This account will be used only in the configuration process and will not be preserved.",
    id: "new-managed-tenant-wizard.general.account-recommendedSubTitle",
  },

  legacySubTitle: {
    defaultMessage: "Specify name of the connection account.",
    id: "new-managed-tenant-wizard.general.account-legacySubTitle",
  },

  // Access to Microsoft Entra ID
  checkButtonTitle: {
    defaultMessage: "Check",
    id: "new-managed-tenant-wizard.consent.check",
  },
  checkConsent: {
    defaultMessage: "Checking consent...",
    id: "new-managed-tenant-wizard.consent.checking-consent",
  },

  consentLabel: {
    defaultMessage: "Consent:",
    id: "new-managed-tenant-wizard.consent.consent-label",
  },
  Unknown: {
    defaultMessage: "Unknown",
    id: "new-managed-tenant-wizard.consent.unknown",
  },
  consentStep: {
    defaultMessage: "Connect to Microsoft Entra ID",
    id: "new-managed-tenant-wizard.consent.stepname",
  },

  finishStep: {
    defaultMessage: "Finish",
    id: "new-managed-tenant-wizard.finish.stepname",
  },
  getConsent: {
    defaultMessage: "Getting consent...",
    id: "new-managed-tenant-wizard.consent.get-consent",
  },
  grantButtonTitle: {
    defaultMessage: "Grant",
    id: "new-managed-tenant-wizard.consent.grant",
  },
  granted: {
    defaultMessage: "Granted",
    id: "new-managed-tenant-wizard.consent.granted",
  },
  notGranted: {
    defaultMessage: "Not granted",
    id: "new-managed-tenant-wizard.consent.not-granted",
  },
  password: {
    defaultMessage: "Account password",
    id: "new-managed-tenant-wizard.general.password",
  },
  tenantRegistration: {
    defaultMessage: "Registering tenant...",
    id: "new-managed-tenant-wizard.general.tenant-registration",
  },
  wizardTitle: {
    defaultMessage: "Add Microsoft 365 tenant",
    id: "new-managed-tenant-wizard.title",
  },

  // global
  closeConfirmation: {
    defaultMessage: "Tenant registration is incomplete.",
    id: "new-managed-tenant.close-confirmation",
  },

  selectMethod: {
    defaultMessage: "Select connection method",
    id: "new-managed-tenant.select-method",
  },

  selectMethodConnect: {
    defaultMessage: "Connection account",
    id: "new-managed-tenant.select-method-connection-account",
  },

  selectMethodPrincipal: {
    defaultMessage: "Create Microsoft Entra application (recommended)",
    id: "new-managed-tenant.select-method-connection-principal",
  },

  tooltipMethodPrincipal: {
    defaultMessage:
      "Microsoft Entra applications allow for granular role assignment and lifecycle governance. They are designed for non-interactive access and are more secure than user accounts.",
    id: "new-managed-tenant.tooltipMethodPrincipal",
  },

  selectMethodConnectOld: {
    defaultMessage: "Use credentials of an existing user account (legacy)",
    id: "new-managed-tenant.select-method-connection-old",
  },

  tooltipMethodConnectOld: {
    defaultMessage:
      "User accounts require credential storage, are harder to govern, and are more prone to compromise. Use only when application-based access cannot be configured.",
    id: "new-managed-tenant.tooltipMethodConnectOld",
  },

  selectMethodConnectReadMore: {
    defaultMessage: "Learn more about Microsoft Entra application accounts",
    id: "new-managed-tenant.select-method-connection-read-more",
  },

  createApplication: {
    defaultMessage: "Configure tenant",
    id: "new-managed-tenant.createApplication",
  },

  createApplicationSignIn: {
    defaultMessage: "Sign In",
    id: "new-partition-wizard.createApplicationSignIn",
  },

  createApplicationSignInLabel: {
    defaultMessage: "Sign in to your tenant using configuration account",
    id: "new-partition-wizard.createApplicationSignInLabel",
  },

  createApplicationSignInLegacyLabel: {
    defaultMessage: "Sign in to your tenant",
    id: "new-partition-wizard.createApplicationSignInLabel",
  },

  createApplicationBannerMsg: {
    defaultMessage:
      "Sign in to your Microsoft Entra tenant using a Global Administrator account so Cayosoft Guardian can automatically create and configure the Microsoft Entra application and assign the required roles.",
    id: "new-managed-tenant.createApplicationBannerMsg",
  },

  createApplicationBannerLegacyMsg: {
    defaultMessage:
      "Cayosoft Guardian will create and configure the Entra application and assign the required permissions.",
    id: "new-managed-tenant.createApplicationBannerLegacyMsg",
  },

  accountField: {
    defaultMessage: "Name of Entra application",
    id: "new-managed-tenant.accountField",
  },

  accountFieldTooltip: {
    defaultMessage:
      "Cayosoft Guardian will automatically register application with this name in your Microsoft Entra tenant.",
    id: "new-managed-tenant.accountFieldTooltip",
  },

  invalidCredentials: {
    defaultMessage: "Invalid credentials",
    id: "new-managed-tenant.invalidCredentials",
  },

  selectService: {
    defaultMessage: "Select services",
    id: "new-managed-tenant.selectService",
  },

  selectService365: {
    defaultMessage: "Select Microsoft 365 services",
    id: "new-managed-tenant.selectService365",
  },

  selectService365Banner: {
    defaultMessage:
      "Cayosoft Guardian will automatically configure the Microsoft Entra application and assign the required roles for each selected service. Enabling data collection for these services grants broad access and affects database storage. {link}",
    id: "new-managed-tenant.selectService365Banner",
  },

  selectService365BannerOld: {
    defaultMessage:
      "Make sure the selected Entra application has the necessary API permissions for the chosen Microsoft 365 services. Enabling data collection for these services grants broad access and affects database storage. {link}",
    id: "new-managed-tenant.selectService365BannerOld",
  },

  selectService365BannerLink: {
    defaultMessage: "Learn more about custom connection accounts in Cayosoft Guardian",
    id: "new-managed-tenant.selectService365BannerLink",
  },

  selectService365List: {
    defaultMessage: "Learn more about custom connection accounts in Cayosoft Guardian",
    id: "new-managed-tenant.selectService365List",
  },

  principalAccountError: {
    defaultMessage: "Account name must be less than or equal to 120 characters.",
    id: "new-managed-tenant.principalAccountError",
  },

  selectServiceEnableCollection: {
    defaultMessage: "Enable data collection from",
    id: "new-managed-tenant.selectServiceEnableCollection",
  },

  selectServiceEntraId: {
    defaultMessage: "Entra ID",
    id: "new-managed-tenant.selectServiceEntraId",
  },
  selectServiceExchangeOnline: {
    defaultMessage: "Exchange Online",
    id: "new-managed-tenant.selectServiceExchangeOnline",
  },
  selectServiceTeams: {
    defaultMessage: "Teams",
    id: "new-managed-tenant.selectServiceTeams",
  },
  selectServiceIntune: {
    defaultMessage: "Intune",
    id: "new-managed-tenant.selectServiceIntune",
  },

  entraTooltip: {
    defaultMessage:
      "Used to monitor changes to Microsoft Entra ID objects, such as users, groups, and roles. Required for most Cayosoft Guardian features.",
    id: "new-managed-tenant.entraTooltip",
  },

  exchangeOnlineTooltip: {
    defaultMessage: "Enables monitoring of mailbox and transport rule changes.",
    id: "new-managed-tenant.exchangeOnlineTooltip",
  },

  intuneTooltip: {
    defaultMessage:
      "Collects data related to mobile device management policies and configurations.",
    id: "new-managed-tenant.intuneTooltip",
  },

  teamsTooltip: {
    defaultMessage: "Monitors Microsoft Teams settings and activities.",
    id: "new-managed-tenant.teamsTooltip",
  },

  entra: {
    defaultMessage: "Entra ID",
    id: "new-managed-tenant.entra",
  },

  exchangeOnline: {
    defaultMessage: "Exchange Online",
    id: "new-managed-tenant.exchangeOnline",
  },

  intune: {
    defaultMessage: "Intune",
    id: "new-managed-tenant.intune",
  },

  teams: {
    defaultMessage: "Teams",
    id: "new-managed-tenant.teams",
  },

  principalFinishTitle: {
    defaultMessage: "Manage tenant",
    id: "new-managed-tenant.principalFinishTitle",
  },

  addNote: {
    defaultMessage:
      "Enabling additional services increases database storage requirements. Estimate your storage needs using the calculator, which can be found in",
    id: "new-managed-tenant.addNote",
  },

  addNoteLink: {
    defaultMessage: "Planning and preparation: Cayosoft Guardian System Requirements.",
    id: "new-managed-tenant.addNoteLink",
  },

  readOnlyCheckbox: {
    defaultMessage: "Grant write permissions for automatic rollback",
    id: "new-managed-tenant-wizard.readOnlyCheckbox",
  },

  readOnlyCheckboxTooltip: {
    defaultMessage:
      "Allows Cayosoft Guardian to roll back changes automatically. Requires write permissions.",
    id: "new-managed-tenant-wizard.readOnlyCheckboxTooltip",
  },
  learnMore: {
    defaultMessage: "Learn more",
    id: "new-managed-tenant.LearnMore",
  },
});

// Exchange online
export const exchangeOnlineMessages = defineMessages({
  stepName: {
    defaultMessage: "Access to Exchange Online",
    id: "new-managed-tenant-wizard.exchange-online.stepname",
  },
  subTitle: {
    id: "new-managed-tenant-wizard.exchange-online.subtitle",
    defaultMessage:
      "Cayosoft Guardian requires administrator consent to access Exchange Online using modern authentication. To grant consent, please obtain a one-time access code, then sign-in to Exchange Online with this code. Cayosoft Guardian would automatically associate successfull sign-in attempt with the consent to access Exchange Online.",
  },
  description1: {
    defaultMessage: "1. Click Get Code to obtain one-time code",
    id: "new-managed-tenant-wizard.exchange-online.step-description1",
  },
  description2: {
    // tslint:disable-next-line: max-line-length
    defaultMessage:
      "2. Click Sign-in. When prompted for code, paste the code provided above and complete sign-in using the Microsoft 365 connection credentials.",
    id: "new-managed-tenant-wizard.exchange-online.step-description2",
  },
  description3: {
    defaultMessage: "3. Wait for Service to identify success sign-in",
    id: "new-managed-tenant-wizard.exchange-online.step-description3",
  },
  getCode: {
    defaultMessage: "Get Code",
    id: "new-managed-tenant-wizard.exchange-online.get-code",
  },
  getCodeError: {
    defaultMessage:
      "Failed to get one-time code. Please check your connection and firewall settings.",
    id: "new-managed-tenant-wizard.exchange-online.get-code-error",
  },
  signIn: {
    defaultMessage: "Sign-in",
    id: "new-managed-tenant-wizard.exchange-online.sign-in",
  },
  oneTimeCode: {
    defaultMessage: "One-time code",
    id: "new-managed-tenant-wizard.exchange-online.one-time-code",
  },
  state: {
    defaultMessage: "State:",
    id: "new-managed-tenant-wizard.exchange-online.state",
  },
  unknown: {
    defaultMessage: "Unknown",
    id: "new-managed-tenant-wizard.exchange-online.unknown",
  },
  gettingOneTimeCode: {
    defaultMessage: "Getting one-time code",
    id: "new-managed-tenant-wizard.getting-one-time-code",
  },
  confirmingConsent: {
    defaultMessage: "confirming consent...",
    id: "new-managed-tenant-wizard.confirming-consent",
  },
  consentError: {
    defaultMessage:
      "Consent was not granted or cannot be identified. Repeat the process from the step 1.",
    id: "new-managed-tenant-wizard.consent-error",
  },
});
